import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDataModel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M7.22 15.997c.028-.21.03-.504.03-.997v-2.25H5c-.493 0-.787.002-.997.03a.7.7 0 0 0-.177.042l-.003.001-.001.003a.7.7 0 0 0-.042.177c-.028.21-.03.504-.03.997v1c0 .493.002.787.03.997a.7.7 0 0 0 .042.177l.001.003.003.001a.7.7 0 0 0 .177.042c.21.028.504.03.997.03h1c.493 0 .787-.002.997-.03a.7.7 0 0 0 .177-.042l.003-.001.001-.003a.7.7 0 0 0 .042-.177m1.487.2c-.048.356-.16.731-.47 1.04s-.684.422-1.04.47c-.323.043-.72.043-1.152.043h-1.09c-.433 0-.83 0-1.152-.043-.356-.048-.731-.16-1.04-.47s-.422-.684-.47-1.04c-.043-.323-.043-.72-.043-1.152v-1.09c0-.433 0-.83.043-1.152.048-.356.16-.731.47-1.04s.684-.422 1.04-.47c.323-.043.72-.043 1.152-.043H8.75v3.795c0 .433 0 .83-.043 1.152M12.78 4.003c-.028.21-.03.504-.03.997v2.25H15c.493 0 .787-.002.997-.03a.7.7 0 0 0 .177-.042l.003-.001.001-.003a.7.7 0 0 0 .042-.177c.028-.21.03-.504.03-.997V5c0-.493-.002-.787-.03-.997a.7.7 0 0 0-.042-.177l-.001-.003-.003-.001a.7.7 0 0 0-.177-.042c-.21-.028-.504-.03-.997-.03h-1c-.493 0-.787.002-.997.03a.7.7 0 0 0-.177.042l-.003.001-.001.003a.7.7 0 0 0-.042.177m-1.487-.2c.048-.356.16-.731.47-1.04s.684-.422 1.04-.47c.323-.043.72-.043 1.152-.043h1.09c.433 0 .83 0 1.152.043.356.048.731.16 1.04.47s.422.684.47 1.04c.043.323.043.72.043 1.152v1.09c0 .433 0 .83-.043 1.152-.048.356-.16.731-.47 1.04s-.684.422-1.04.47c-.323.043-.72.043-1.152.043H11.25V4.955c0-.433 0-.83.043-1.152m4.884 3.374"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="m7.47 11.47 4-4 1.06 1.06-4 4z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDataModel;
